module.exports = __webpack_public_path__ + "static/pillow-4-c660fffa88f6395f44c68c3002f9a0c7.webp";